import httpClient from './httpClient';

export interface LideraAIReference {
  label: string;
  link: string;
}

export interface LideraAIAnswer {
  answer: string;
  toolUsed?: string;
  references: LideraAIReference[];
}

export const lideraAIService = {
  async chat(message: string): Promise<LideraAIAnswer> {
    const response = await httpClient.post<LideraAIAnswer>('/lidera-ai/chat', { message });
    if (!response.data) {
      throw new Error('A Lidera IA não retornou uma resposta válida.');
    }
    return response.data;
  },
};
